export const MAX_HEIGHT_PERCENTAGE = 50;
export const TEXTAREA_MIN_ROWS = 1;
